(function fullImageViewerHeader(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  const previousFullImageViewerHeader = global.NewHomeSource.FullImageViewerHeader;

  /**
 * @private
 * getTextContent: return textContent from element.
 *
 * @param {HTMLElement} element to get text.
 */
  function getTextContent(element) {
    return element.textContent;
  }

  /**
   * @public
   * render: renders the Header of the Full Image Viewer.
   *
   * @param {HTMLElement} header where the information is going to be added.
   * @param {HTMLElement} information that is going to be added in the header.
   */
  function render(header, information) {
    const subtitle = global.document.querySelector('[full-image-viewer-role="subtitle"]');
    const subtitleText = [].slice.call(global.document.querySelectorAll('[data-full-image-viewer-role="subtitle"]'));

    if (subtitle && subtitleText.length > 0) {
      subtitle.textContent = subtitleText.map(getTextContent).join(' ');
    }

    header.appendChild(information.cloneNode(true));
  }

  /**
   * @constructs NewHomeSource.FullImageViewerHeader
   */
  function FullImageViewerHeader() {
  }

  /**
   * @public
   * appendInformation: reads the information from the current header and
   * appends it to the Full Image Viewer.
   */
  FullImageViewerHeader.appendInformation = function appendInformation() {
    const header = global.document.querySelector('[full-image-viewer-role="header"]');
    const information = global.document.querySelector('[data-full-image-viewer-role="header"]');

    if (!header || !information) {
      return;
    }

    requestAnimationFrame(render.bind(this, header, information));
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.FullImageViewer to the previous script.
   */
  FullImageViewerHeader.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewerHeader = previousFullImageViewerHeader;
    return FullImageViewerHeader;
  };

  global.NewHomeSource.FullImageViewerHeader = FullImageViewerHeader;
}(window));
